/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

const PROMPT_V2_SERVICE_TYPE = Object.freeze({
  CATALOGUE: 'catalogue',
  VERSION: 'version',
  VERSIONS: 'versions',
  UPDATE: 'update',
  NAME_AVAILABILITY: 'nameAvailability',
  VERSION_GRAPHS: 'versionGraphs'
});

export default PROMPT_V2_SERVICE_TYPE;
